export default __webpack_public_path__ + "static/media/stage3_phn.9d849880.png";